module.exports = __webpack_public_path__ + "assets/img/backs.02098bda.jpg";